import type { Feature, LineString } from "geojson"
import type { LngLatBoundsLike } from "maplibre-gl"
import type { MapViewData, MapViewPolyline } from "@/lib/aiWidgetMapParser"

export function computeBounds(data: MapViewData): LngLatBoundsLike | null {
  const lngs: number[] = []
  const lats: number[] = []
  for (const m of data.markers) {
    lngs.push(m.lon)
    lats.push(m.lat)
  }
  for (const pl of data.polylines) {
    for (const p of pl.points) {
      lngs.push(p.lon)
      lats.push(p.lat)
    }
  }
  if (lngs.length === 0) return null
  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ]
}

export function polylineFeature(pl: MapViewPolyline): Feature<LineString> {
  return {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: pl.points.map((p) => [p.lon, p.lat]),
    },
  }
}
